import FormField from '../swedish-private-v2/form-field';
import InputPersonalId from '../swedish-private-v2/input-personal-id';
import FormHeader, { SwedenCountryCode } from '../../common/form/form-header';
import { Heading } from '../../common/form/form-parts';
import GoogleIcon from '@tradera/blueprint/theme/icons-colored/google.svg?jsx';
import WarningIcon from '@tradera/blueprint/theme/icons/warning.svg?jsx';
import { FormFooter } from '../../common/form/form-footer';
import { useTranslator, useUrlLocalizer } from 'tradera/lang/translate';
import { getAvailableUserRegistrationCountries } from 'tradera/apps/registration/helpers/get-available-user-registration-countries';
import { SelectCountry } from '../../common/form/select-country';
import { GoogleSignupButton } from '../google-signup-button';
import { Button } from 'tradera/components/atoms/button/button';
import {
    AppleButton,
    FacebookButton,
    KlarnaButton
} from 'tradera/components/social-buttons/social-buttons';

export const SwedishPrivateFormStep1 = (props) => {
    const {
        appleEnabled,
        appleNotLoaded,
        facebookEnabled,
        facebookNotLoaded,
        form,
        googleEnabled,
        googleNotLoaded,
        klarnaEnabled,
        klarnaNotLoaded,
        isNativeAppContext,
        onAppleStart,
        onFacebookStart,
        onGoogleStart,
        onKlarnaStart,
        onNavigate
    } = props;
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();
    const availableCountries = getAvailableUserRegistrationCountries(t);
    return (
        <>
            <FormHeader showLanguageMenu={false} />
            <div>
                <div className="text-center" data-form-step="1">
                    <Heading>Skapa konto gratis</Heading>
                    <p className="mb-3">
                        Välkommen till Sveriges största marknadsplats.
                    </p>
                    <SelectCountry
                        availableCountries={availableCountries}
                        onCountrySelected={(selectedValue) => {
                            window.location.href = `${toLocalizedUrl(
                                '/register/foreign-private'
                            )}?countryCode=${selectedValue}`;
                        }}
                        selectedCountryCodeIso2={SwedenCountryCode}
                    />
                    {(facebookEnabled ||
                        appleEnabled ||
                        googleEnabled ||
                        klarnaEnabled) && (
                        <div className="border-bottom mb-4 position-relative">
                            <div className="text-center py-2">
                                <div>
                                    {googleEnabled && (
                                        <>
                                            {isNativeAppContext ? (
                                                <Button
                                                    theme="action"
                                                    variant="outline"
                                                    fluid
                                                    className="google-register-button position-relative mb-2"
                                                    aria-label={
                                                        'Fortsätt med Google'
                                                    }
                                                    disabled={googleNotLoaded}
                                                    onClick={onGoogleStart}
                                                    icon={<GoogleIcon />}
                                                    fixedIcon>
                                                    Fortsätt med Google
                                                </Button>
                                            ) : (
                                                <GoogleSignupButton
                                                    googleAppId={
                                                        props.googleAppId
                                                    }
                                                    onCallback={onGoogleStart}
                                                />
                                            )}
                                            {googleNotLoaded && (
                                                <div className="alert alert-warning text-left d-flex">
                                                    <WarningIcon className="icon flex-shrink-0 mr-4 align-baseline" />
                                                    <span>
                                                        Google-inloggning kunde
                                                        inte startas. Ladda om
                                                        sidan eller registrera
                                                        dig med e-postadress
                                                        ovan.
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {klarnaEnabled && (
                                        <>
                                            <KlarnaButton
                                                disabled={klarnaNotLoaded}
                                                onClick={onKlarnaStart}
                                                className="mb-2">
                                                Fortsätt med Klarna
                                            </KlarnaButton>
                                            {klarnaNotLoaded && (
                                                <div className="alert alert-warning text-left d-flex">
                                                    <WarningIcon className="icon flex-shrink-0 mr-4 align-baseline" />
                                                    <span>
                                                        Klarna-inloggning kunde
                                                        inte startas. Ladda om
                                                        sidan eller registrera
                                                        dig med e-postadress
                                                        ovan.
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {appleEnabled && (
                                        <>
                                            <AppleButton
                                                className="mb-2"
                                                disabled={appleNotLoaded}
                                                onClick={onAppleStart}>
                                                Fortsätt med Apple
                                            </AppleButton>
                                            {appleNotLoaded && (
                                                <div className="alert alert-warning text-left d-flex">
                                                    <WarningIcon className="icon flex-shrink-0 mr-4 align-baseline" />
                                                    <span>
                                                        Apple-inloggning kunde
                                                        inte startas. Ladda om
                                                        sidan eller registrera
                                                        dig med e-postadress
                                                        ovan.
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {facebookEnabled && (
                                        <>
                                            <FacebookButton
                                                className="mb-2"
                                                aria-label={
                                                    'Fortsätt med Facebook'
                                                }
                                                disabled={facebookNotLoaded}
                                                onClick={onFacebookStart}>
                                                Fortsätt med Facebook
                                            </FacebookButton>
                                            {facebookNotLoaded && (
                                                <div className="alert alert-warning text-left d-flex">
                                                    <WarningIcon className="icon flex-shrink-0 mr-4 align-baseline" />
                                                    <span>
                                                        Facebook-inloggning
                                                        kunde inte startas.
                                                        Ladda om sidan eller
                                                        registrera dig med
                                                        e-postadress ovan.
                                                    </span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                            <div
                                className="text-center position-absolute"
                                style={{
                                    transform: 'translate(-50%, 50%)',
                                    bottom: 0,
                                    left: '50%'
                                }}>
                                <span className="size-paris text-styled font-weight-bold bg-white pill px-3">
                                    eller
                                </span>
                            </div>
                        </div>
                    )}
                    <FormField
                        containerClassName="mb-2"
                        className="px-3 py-2"
                        form={form}
                        field="EmailAddress"
                        placeholder="E-postadress"
                        type="email"
                    />
                    <FormField
                        containerClassName="mb-2"
                        className="px-3 py-2"
                        form={form}
                        field="PersonalNumber"
                        inputComponent={InputPersonalId}
                        placeholder="Personnummer (ÅÅMMDDNNNN)"
                        hint="Syftet med att lämna personnummer är att öka din säkerhet då ingen är anonym när man gör affärer på Tradera. Dina personuppgifter lagras i en skyddad miljö och lämnas aldrig ut till obehöriga."
                    />
                    <Button
                        theme="primary"
                        fluid
                        onClick={onNavigate}
                        aria-label={'Registrera'}
                        id="navigate_next"
                        data-register-submit="">
                        Skapa nytt konto
                    </Button>
                </div>
            </div>
            <FormFooter
                registerLink={toLocalizedUrl('/register/swedish-company')}
                isCompanyLink={true}
            />
        </>
    );
};
